module.exports = __webpack_public_path__ + "img/etn.4dfbc846.svg";